import ShingleRow from './ShingleRow';

const ShingleList = ({ shingles, ...props }) => (
  shingles.map(shingle => {
    return <ShingleRow
      shingle={shingle}
      key={shingle.uid}
      {...props}
     />
  })
)

export default ShingleList;
